import request from '@/utils/request'

/**
 * @apiName 对账单汇总列表
 * @params  data {billId:账单ID,billCycleStart:账单周期开始时间,billCycleEnd:账单周期截止时间}
 */
export function reconciliationSummaryListApi(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/summary/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 对账单订单明细列表
 * @params  data {billId:账单ID,orderId:订单编号,orderType:订单类型 1-应收(支付)，2-应付(退款)
 * serialNumber:流水号,tradeTimeStart:交易时间开始,tradeTimeEnd:交易时间结束}
 */
export function reconciliationTradeDetailListApi(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/tradeDetail/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 对账单核销订单明细列表
 * @params  data {billId:账单ID,orderId:订单编号,orderType:订单类型 1-应收(支付)，2-应付(退款)
 * serialNumber:流水号,tradeTimeStart:交易时间开始,tradeTimeEnd:交易时间结束}
 */
export function reconciliationOffsetDetailListApi(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/offsetDetail/list',
    method: 'POST',
    data,
  })
}


export const reconciliationListApi = new Map([
  ['0', reconciliationTradeDetailListApi],
  ['1', reconciliationOffsetDetailListApi],
])
